import { capitalize } from 'lodash';
import countries from '../../../Lib/Constants/countries';

export default {
  pageTitle: 'Production Facility Profile',
  cards: [
    {
      title: 'Details',
      fields: [
        {
          label: 'Factory Name',
          name: 'factoryName',
          required: true,
          type: 'text',
        },
        {
          label: 'Status',
          name: 'status',
          required: true,
          type: 'select',
          options: ['Active', 'Inactive', 'Pending', 'Suspended'].map(
            (status) => ({
              label: status,
              value: status,
            }),
          ),
        },
        {
          label: 'Country',
          name: 'country',
          required: true,
          type: 'select',
          options: countries.map((country) => ({
            label: country.text,
            value: country.value,
          })),
        },
        {
          label: 'Main Product Type',
          name: 'mainProductType',
          required: true,
          type: 'text',
        },
      ],
    },
    {
      title: 'Ownership & Interest',
      fields: [
        {
          label: 'Is the factory publicly or privately owned?',
          name: 'ownership',
          required: true,
          type: 'select',
          options: ['Publicly Owned', 'Privately Owned'].map((ownership) => ({
            label: ownership,
            value: ownership,
          })),
        },
        {
          label: 'Is there government interest in the factory?',
          name: 'governmentInterest',
          required: true,
          type: 'yes_no',
        },
      ],
    },
    {
      title: 'Compliance',
      fields: [
        {
          label: 'Is factory ASN Ready?',
          name: 'asnReady',
          required: true,
          type: 'yes_no',
        },
        {
          label: 'Is the factory WRAP certified?',
          name: 'wrapCertified',
          required: true,
          type: 'radios',
          options: ['yes', 'no', 'in process'].map((wrapCertified) => ({
            label: capitalize(wrapCertified),
            value: wrapCertified,
          })),
        },
        {
          label: 'Is the factory SA8000 certified?',
          name: 'sa8000Certified',
          required: true,
          type: 'yes_no',
        },
        {
          label: 'Is the factory C-TPAT compliant?',
          name: 'ctpatCompliant',
          required: true,
          type: 'radios',
          options: ['yes', 'no', 'in process'].map((ctpatCompliant) => ({
            label: capitalize(ctpatCompliant),
            value: ctpatCompliant,
          })),
        },
      ],
    },
  ],
};
